<app-form (submit)="updateUser()">
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">Assign user</h3>
        </div>
        <div class="card-body">
            <div class="mb-3">
                <label class="form-label">User</label>
                <div class="d-flex gap-2 align-items-center">
                    <div class="flex-grow-1 notranslate">
                        <app-search [minCharacters]="0" [(ngModel)]="user" required [searchFunction]="searchUsers"
                                    [inputFormatter]="refDataUtils.userFormatter" (ngModelChange)="onUserSelected($event)"
                                    placeholder="Search for a user"></app-search>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between">
            <a class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
            <button type="submit" class="btn btn-primary">Save changes</button>
        </div>
    </div>
</app-form>

